// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"323":"add3bd9d","813":"2a2f00cf","839":"add3bd9d"}[chunkId] + ".chunk.css";
};